import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
export function TargetAudience() {
  const forWho = ['Creyentes que saben que están destinados a más pero se sienten estancados.', 'Emprendedores que quieren basar su éxito en principios bíblicos inamovibles.', 'Cualquier persona cansada de la ansiedad financiera que busca paz mental y resultados reales.', 'Hombres y mujeres que quieren ser canales de bendición para otros.'];
  const notForWho = ['Personas que buscan "dinero mágico" sin compromiso espiritual ni acción.', 'Cínicos que no creen en el poder de la palabra escrita ni en la autoridad bíblica.', 'Quienes prefieren seguir quejándose de la economía en lugar de cambiar su lenguaje.'];
  return <section className="py-24 bg-parchment" data-id="element-231">
      <div className="container mx-auto px-4" data-id="element-232">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12" data-id="element-233">
          {/* Who this is for */}
          <FadeIn direction="right" data-id="element-234">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-green-100 h-full" data-id="element-235">
              <h3 className="text-2xl md:text-3xl font-bold text-navy mb-8 border-b border-gray-100 pb-4" data-id="element-236">
                Esto ES para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-237">
                {forWho.map((item, i) => <li key={i} className="flex gap-4" data-id="element-238">
                    <div className="shrink-0 mt-1 bg-green-100 p-1 rounded-full" data-id="element-239">
                      <CheckIcon className="w-5 h-5 text-green-700" data-id="element-240" />
                    </div>
                    <p className="text-charcoal leading-relaxed" data-id="element-241">{item}</p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who this is NOT for */}
          <FadeIn direction="left" delay={0.2} data-id="element-242">
            <div className="bg-white/50 p-8 md:p-10 rounded-2xl border border-red-100 h-full" data-id="element-243">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-400 mb-8 border-b border-gray-100 pb-4" data-id="element-244">
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-245">
                {notForWho.map((item, i) => <li key={i} className="flex gap-4 opacity-75" data-id="element-246">
                    <div className="shrink-0 mt-1 bg-red-50 p-1 rounded-full" data-id="element-247">
                      <XIcon className="w-5 h-5 text-red-400" data-id="element-248" />
                    </div>
                    <p className="text-gray-600 leading-relaxed" data-id="element-249">{item}</p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}